import { useEffect } from 'react';

// This module tracks where users come from when they visit an event through a tracking link
// It captures the 'fdsrc' parameter from the URL and stores it in local storage
// We log a page view the first time the user reaches the event page with the 'fdsrc' parameter
// We then include the `fdsrc` slug with any purchase the user makes
// When the user visits from a different source, we replace the existing slug in local storage
// All sales are attributed to the last source slug captured

let currentEventId = null;

class SourceTracker {
    pageView() {
        const sourceSlug = localStorage.getItem(`fdsrc-${currentEventId}`);

        if (sourceSlug) {
            fetch(`${process.env.REACT_APP_API_URL}/store_api/events/${currentEventId}/page-view`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ fdsrc: sourceSlug }),
            })
                .catch((e) => console.error(e)); // Ignore errors, as this is not critical to the app's functionality
        }
    }

    getSourceSlug() {
        return localStorage.getItem(`fdsrc-${currentEventId}`);
    }
}

export const sourceTracker = new SourceTracker();


export function useSourceTracker(eventId) {
    useEffect(() => {
        if (!window || !eventId) return;

        // Set the current event ID for tracking
        currentEventId = eventId;

        // Get the fdsrc slug from URL parameters
        const params = new URLSearchParams(window.location.search);
        const sourceSlug = params.get('fdsrc');

        if (sourceSlug) {
            // Store fdsrc slug in local storage
            localStorage.setItem(`fdsrc-${eventId}`, sourceSlug);

            // Initial page view after fdsrc is captured
            sourceTracker.pageView();
        }

        return () => {
            currentEventId = null;
        };
        
    }, [eventId]);
}
